/* eslint-disable */
// import React from "react";

// const PerformanceLogic = () => {
//     const legendItems = [
//         { color: "#28a745", label: "≥ 90% (Excellent)" },
//         { color: "#ffc107", label: "80%-89% (Good)" },
//         { color: "#dc3545", label: "< 80% (Critical)" },
//     ];

//     return (
//         <div style={{
//             display: "flex",
//             alignItems: "center",
//             padding: "5px 25px",
//             backgroundColor: "#f5f5f5",
//             borderRadius: "8px",
//             gap: "20px",
//             fontFamily: "Arial, sans-serif",
//             fontSize: "12px",
//             color: "#333"
//         }}>
//             <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
//                 <i style={{
//                     width: "16px",
//                     height: "16px",
//                     borderRadius: "50%",
//                     backgroundColor: "#17a2b8",
//                     display: "inline-block",
//                     textAlign: "center",
//                     lineHeight: "16px",
//                     fontStyle: "normal",
//                     color: "#fff"
//                 }}>i</i>
//                 <span>Performance Logic</span>
//             </span>

//             {legendItems.map((item, idx) => (
//                 <div key={idx} style={{ display: "flex", alignItems: "center", gap: "6px" }}>
//                     <span style={{
//                         width: "14px",
//                         height: "14px",
//                         borderRadius: "50%",
//                         backgroundColor: item.color,
//                         display: "inline-block"
//                     }}></span>
//                     <span>{item.label}</span>
//                 </div>
//             ))}
//         </div>
//     );
// };

// export default PerformanceLogic;

// ################ Responsive code ###################


// import React from "react";

// const PerformanceLogic = () => {
//     const legendItems = [
//         { color: "#28a745", label: "≥ 90% (Excellent)" },
//         { color: "#ffc107", label: "80%-89% (Good)" },
//         { color: "#dc3545", label: "< 80% (Critical)" },
//     ];

//     return (
//         <div
//             style={{
//                 display: "flex",
//                 flexWrap: "wrap",                     // ⭐ Responsive WRAP
//                 alignItems: "center",
//                 padding: "8px 15px",
//                 // backgroundColor: "#f5f5f5",
//                 backgroundColor: "rgb(0 243 255 / 23%)",
//                 borderRadius: "8px",
//                 gap: "12px 20px",                     // row gap, column gap
//                 fontFamily: "Arial, sans-serif",
//                 fontSize: "12px",
//                 color: "#333",
//             }}
//         >
//             {/* Title Section */}
//             <span
//                 style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "6px",
//                     flexShrink: 0,
//                 }}
//             >
//                 <i
//                     style={{
//                         width: "16px",
//                         height: "16px",
//                         borderRadius: "50%",
//                         backgroundColor: "#17a2b8",
//                         display: "inline-flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         fontSize: "10px",
//                         color: "#fff",
//                         fontStyle: "normal",
//                     }}
//                 >
//                     i
//                 </i>
//                 <span style={{ fontWeight: 600 }}>Performance Logic</span>
//             </span>

//             {/* Legend Items */}
//             <div
//                 style={{
//                     display: "flex",
//                     flexWrap: "wrap",                // ⭐ Responsive WRAP for items
//                     gap: "10px 20px",
//                 }}
//             >
//                 {legendItems.map((item, idx) => (
//                     <div
//                         key={idx}
//                         style={{
//                             display: "flex",
//                             alignItems: "center",
//                             gap: "6px",
//                         }}
//                     >
//                         <span
//                             style={{
//                                 width: "14px",
//                                 height: "14px",
//                                 borderRadius: "50%",
//                                 backgroundColor: item.color,
//                                 display: "inline-block",
//                             }}
//                         ></span>
//                         <span>{item.label}</span>
//                     </div>
//                 ))}
//             </div>
//         </div>
//     );
// };

// export default PerformanceLogic;



import React from "react";

const PerformanceLogic = () => {
    const legendItems = [
        { color: "#28a745", label: "≥ 90% (Excellent)" },
        { color: "#ffc107", label: "80%-89% (Good)" },
        { color: "#dc3545", label: "< 80% (Critical)" },
    ];

    return (
        <div
            style={{
                width: "100%",            // FULL WIDTH
                overflow: "hidden",
                whiteSpace: "nowrap",
            }}
        >
            {/* Marquee wrapper (left → right) */}
            <div
                className="marquee-content"
                style={{
                    display: "inline-flex",
                    animation: "marquee-ltr 25s linear infinite",
                }}
            >
                {/* Content Block */}
                <div
                    style={{
                        display: "flex",
                        flexWrap: "wrap",
                        alignItems: "center",
                        padding: "8px 15px",
                        backgroundColor: "#00fffb3b",
                        borderRadius: "8px",
                        gap: "12px 20px",
                        fontFamily: "Arial, sans-serif",
                        fontSize: "10px",
                        color: "#333",
                    }}
                >
                    {/* Title */}
                    <span
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            flexShrink: 0,
                        }}
                    >
                        <i
                            style={{
                                width: "16px",
                                height: "16px",
                                borderRadius: "50%",
                                backgroundColor: "#17a2b8",
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: "10px",
                                color: "#fff",
                                fontStyle: "normal",
                            }}
                        >
                            i
                        </i>
                        <span style={{ fontWeight: 600 }}>Performance Logic</span>
                    </span>

                    {/* Items */}
                    <div
                        style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "10px 20px",
                        }}
                    >
                        {legendItems.map((item, idx) => (
                            <div
                                key={idx}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                }}
                            >
                                <span
                                    style={{
                                        width: "14px",
                                        height: "14px",
                                        borderRadius: "50%",
                                        backgroundColor: item.color,
                                        display: "inline-block",
                                    }}
                                ></span>
                                <span>{item.label}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* CSS Animation */}
            <style>
                {`
                @keyframes marquee-ltr {
                    0%   { transform: translateX(-100%); }
                    100% { transform: translateX(100%); }
                }

                .marquee-content:hover {
                    animation-play-state: paused;
                }
            `}
            </style>
        </div>
    );
};

export default PerformanceLogic;

